import React from 'react';
import styled from 'styled-components';
import { Grid } from '../components/grid/Grid';
import { Section, SectionContent } from '../components/Section';
import { ServiceCard } from '../components/ServiceCard';
import { Heading } from '../components/typography/Heading';
import { SubHeading } from '../components/typography/SubHeading';
import { IconType } from 'react-icons';

const StyledHeading = styled(Heading)`
  margin-bottom: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    max-width: 250px;
  }
`;

export enum GridLayout {
  ThreeByThree = 'THREE_BY_THREE',
  TwoByTwo = 'TWO_BY_TWO',
}

export interface Service {
  icon: string | IconType;
  title: string;
  description: string;
}

export interface ServicesSectionProps {
  services: Service[];
  heading: string;
  subHeading: string;
  layout?: GridLayout;
}

export const ServicesSection: React.FC<ServicesSectionProps> = (props) => {
  const columns = props.layout === GridLayout.TwoByTwo ? 2 : 3;

  return (
    <Section backgroundColor="#ECF6FF">
      <SectionContent>
        <SubHeading>{props.subHeading}</SubHeading>
        <StyledHeading dangerouslySetInnerHTML={{ __html: props.heading }} />
        <Grid columns={columns}>
          {props.services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </Grid>
      </SectionContent>
    </Section>
  );
};
